import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { OpenDialogAddEditPracticePlaceComponent } from 'app/components/dialog/open-dialog-add-edit-practice-place/open-dialog-add-edit-practice-place.component';
import { CodeClub } from 'app/shared/models/class/club/club';
import { PracticePlace } from 'app/shared/models/class/practice-place/PracticePlace';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { ClubService } from 'app/shared/services/club/club.service';
import { DataService } from 'app/shared/services/data/data.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { PracticePlaceService } from 'app/shared/services/practice-place/pratcice-place.service';

@Component({
  selector: 'app-admin-practice-place',
  templateUrl: './admin-practice-place.component.html',
  styleUrls: ['./admin-practice-place.component.scss']
})
export class AdminPracticePlaceComponent implements OnInit {

  searchForm: UntypedFormGroup;
  searchPracticePlaceForm: UntypedFormGroup;
  valueInput: string;

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  displayedColumns: string[] = ['city', 'address', 'edit', 'delete'];
  dataSource: MatTableDataSource<PracticePlace>;

  length: number;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 50];
  pageEvent: PageEvent;

  color: ThemePalette = 'primary';

  pacticePlace: PracticePlace[];
  userConnected: any;
  clubs: CodeClub[];
  title: string;
  addPlace = false;
  newPracticeplace = new PracticePlace();
  clubCode: any;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private authService: AuthService,
    private clubService: ClubService,
    private practicePlaceService: PracticePlaceService,
    private dataService: DataService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private faIconService: FaiconService,
  ) {
  }

  ngOnInit() {
    this.initComponent();
    this.initForm();
    this.getElementByRole();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  applyFilter(event): void {
    this.valueInput = event;
    this.dataService.valueFilterPracticePlace$.next(event);
  }

  resetSearch(): void {
    this.searchForm.get('keyword').setValue('');
    this.dataService.valueFilterPracticePlace$.next('');
    this.valueInput = '';
  }

  addPracticePlace(action: string): void {
    const dialogRef = this.dialog.open(OpenDialogAddEditPracticePlaceComponent, {
      data: { action }
    });

    dialogRef.afterClosed().subscribe({
      next: () => {
        this.dataService.updatePracticePlace$.next(true);
      }
    });
  }

  getAddressPracticePlace(event): void {
    event.address_components.forEach(el => {

      switch (el.types[0]) {
        case 'street_number':
          this.newPracticeplace.box = el.long_name;
          break;
        case 'route':
          this.newPracticeplace.address = el.long_name;
          break;
        case 'locality':
          this.newPracticeplace.city = el.long_name;
          break;
        case 'postal_code':
          this.newPracticeplace.postalCode = el.long_name;
          break;

        default:
          break;
      }
    });

    this.newPracticeplace.latitude = event.geometry.location.lat();
    this.newPracticeplace.longitude = event.geometry.location.lng();
    this.newPracticeplace.clubCode = this.clubCode;

  }

  get practicePlaceControls() {
    return this.searchPracticePlaceForm.controls;
  }

  private getElementByRole(): void {

    const title = {
      // club: 'Liste des disciplines de mon club',
      club: `Liste des disciplines d'un acteur`,
      admin: `Gestion des disciplines de l'acteur : ${this.clubCode}`

    };

    this.title = title[this.userConnected.role];
    if (this.userConnected.role === ' admin') { this.getClubs(); }
  }

  private getClubs(): void {
    this.clubService.getClubs().subscribe({
      next: clubs => this.clubs = clubs
    });
  }

  private initComponent(): void {
    this.userConnected = this.authService.getDecodedToken();
    this.clubCode = this.route.snapshot.queryParams.clubCode && this.userConnected.role === 'admin' ?
      this.route.snapshot.queryParams.clubCode : this.userConnected.club_code;

  }

  private initForm(): void {
    this.searchForm = this.formBuilder.group({
      keyword: ['']
    });
    this.searchPracticePlaceForm = this.formBuilder.group({
      practicePlace: ['']
    });
  }


}
